import axios from 'axios'
import { apiUrl, getWithExpiry } from '../App'


export function getApiUrl(params) {

  if (params != null)
    return axios.create({
      baseURL: apiUrl,
      headers: authHeader(),
      params: params,
    })
  else return axios.create({
    baseURL: apiUrl,
    headers: authHeader(),
  })
}

export function authHeader() {
  let userState = getWithExpiry('token')
  if (userState && userState.token) {
    return { Authorization: 'Bearer ' + userState.token, 'X-Smartdorm-Dorm-ID': '4885b6d1-bbe4-4d40-bd24-bce33f0d7728' }
  } else {
    return { 'X-Smartdorm-Dorm-ID': '4885b6d1-bbe4-4d40-bd24-bce33f0d7728' }
  }
}